
const appsTorneoRutes = [
  // url para aplicaciones de un torneo
  {
    path: 'news',
    name: 'torneo-admin-news',
    component: () => import('../views/torneoApps/NewsTorneoAdminPage.vue'),
  },
  {
    path: 'torneo/control-tarjetas',
    component: () => import('../viewshop/torneoApps/PayTarjetasPage.vue'),
    name: 'app-pay-tarjeta'
  },
  
]

export default appsTorneoRutes
